var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{staticClass:"modal-box",attrs:{"id":"questionRadius","size":"lg","ok-only":true,"lazy":true,"hide-header":""}},[_c('iframe',{attrs:{"src":_vm.link,"width":"100","frameborder":"0","scrolling":"no","marginheight":"0","marginwidth":"0"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40ac5c94","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/MQuestionRadius.vue
// module id = null
// module chunks = 